export enum DoorPrepReferencePoint {
  TDCL = 'Top of Door to Centerline',
  TDT = 'Top of Door to Top',
  FFB = 'Finished Floor to Bottom',
  FFCL = 'Finished Floor to Centerline',
  BDB = 'Bottom of Door to Bottom',
  BDCL = 'Bottom of Door to Centerline',
}
